import { Box, Container } from '@material-ui/core'
import { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import { useSearchParams } from "react-router-dom";
import AddUpdateDialog from 'src/components/common/addUpdateDialog';
import FilterSection from 'src/components/common/filterSection'
import AddEditExcerciseMaster from 'src/components/exercise/AddEditExcerciseMaster'
import useQueryTable from 'src/hooks/useQueryTable'
import { DeleteExerciseMasterById, GetExerciseMasters } from 'src/redux/actions'
import { LocalTable } from 'src/ui/Table'
import { GetExerciseMasterTableColumns } from 'src/util/columns'

const ExerciseMasterList = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams();
  const [recordToEdit, setRecordToEdit] = useState()
  const [customFilterQuery, setCustomFilterQuery] = useState()
  const lessonId = searchParams.get('lessonId');
  const [searchText, setSearchText] = useState(null)
  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  // get exercise masters API
  // useEffect(() => {
  //   dispatch(GetExerciseMasters())
  // }, [dispatch])

  const { data, isLoading, isFetching, refetch } = useQueryTable({
    name: 'exerciseMasters',
    searchText: searchText,
    pageIndex: pageIndex,
    pageSize: pageSize,
    additionalFilters: customFilterQuery,
  })

  // set exerciseMasterId in customFilterQuery if present in url params
  useEffect(() => {
    const exerciseMasterId = searchParams.get('_id');
    if (exerciseMasterId) {
      setCustomFilterQuery(prev => ({
        ...prev,
        _id: exerciseMasterId,
      }))
    }
  }, [searchParams]);

  // filter practice list by lessonId
  useEffect(() => {
    setCustomFilterQuery(prev => {
      const updatedQuery = { ...(prev || {}) };

      if (lessonId) {
        updatedQuery.lesson = lessonId;
      } else {
        delete updatedQuery.lesson;
      }

      return updatedQuery;
    });
  }, [lessonId]);


  const onDeleteRow = async recordToDelete => {
    if (recordToDelete) {
      await dispatch(DeleteExerciseMasterById(recordToDelete))
      refetch()
    }
  }

  const columns = useMemo(() => GetExerciseMasterTableColumns(), []);

  return (
    <>
      <Helmet>
        <title>Exercise Masters | Langistan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          {/* addButton filters & search section  */}
          <FilterSection
            type="Practice List"
            setSearchText={setSearchText}
            setRecordToEdit={setRecordToEdit}
            dispatcher={GetExerciseMasters}
            setCustomFilterQuery={setCustomFilterQuery}
            isViewFilterPanel={lessonId ? false : true}
          />
          {/* Exercise Master list */}
          <Box sx={{ pt: 3 }}>
            <LocalTable
              columns={columns}
              onEditClick={setRecordToEdit}
              onDeleteClick={onDeleteRow}
              additionalFilters={customFilterQuery}
              data={data}
              name="practice list"
              isLoading={isLoading}
              isFetching={isFetching}
              setPagination={setPagination}
            />
          </Box>

          {/* Add & Update practice List */}
          <AddUpdateDialog
            open={!!recordToEdit}
            title={`${Object.keys(recordToEdit ?? {}).length ? "Update" : "Create"} Practice List`}
            onClose={() => {
              setRecordToEdit();
            }
            }
            maxWidth="lg"
          >
            <Box mt={2}>
              <AddEditExcerciseMaster
                selectedRow={recordToEdit}
                toggleDrawer={() => {
                  setRecordToEdit();
                }}
                refetch={refetch}
              />
            </Box>
          </AddUpdateDialog>
        </Container>
      </Box >
    </>
  )
}

export default ExerciseMasterList
